import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/shared/login.service';
import { ProfileService } from 'src/app/shared/profile.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  userGroup: any = [];
  loginDisplay = false;
  perfilAdmin = false;
  perfilPatrocInterna = false;
  perfilNormativo = false;
  perfilTecnico = false;
  perfilCadastro = false;
  perfilArrecadacao = false;
  perfilEmprestimo = false;
  perfilConsignataria = false;
  perfilCalculoRetroativo = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private loginService: LoginService,
    private perfilService: ProfileService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.loginService.user$.subscribe((user) => {
        this.loginDisplay = !!user;
        if (user) {
          this.perfilService.verificarPerfis();
          this.carregarPerfis();
        }
      })
    );
  }

  carregarPerfis() {
    this.perfilAdmin = this.perfilService.getPerfilAdmin();
    this.perfilPatrocInterna = this.perfilService.getPerfilPatrocInterna();
    this.perfilNormativo = this.perfilService.getPerfilNormativo();
    this.perfilTecnico = this.perfilService.getPerfilTecnico();
    this.perfilCadastro = this.perfilService.getPerfilCadastro();
    this.perfilArrecadacao = this.perfilService.getPerfilArrecadacao();
    this.perfilEmprestimo = this.perfilService.getPerfilEmprestimo();
    this.perfilConsignataria = this.perfilService.getPerfilConsignataria();
    this.perfilCalculoRetroativo = this.perfilService.getPerfilCalculoRetroativo();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
